import gql from 'graphql-tag';

import {
  type SelectedAccountEntityOrgQuery,
  useSelectedAccountEntityOrgQuery,
} from '../generated/graphql';

export const SELECTED_ACCOUNT_ENTITY_ORG_QUERY = gql`
  query SelectedAccountEntityOrg($id: ID!) {
    organization(id: $id) {
      id
      orgEntity {
        id
        name
      }
    }
  }
`;

export type SelectedAccountEntityOrg = Omit<
  NonNullable<
    NonNullable<SelectedAccountEntityOrgQuery>['organization']
  >['orgEntity'],
  '__typename'
>;

/**
 *
 * @param orgId
 * @returns The entity object for the specified orgId. The entities table contains both regular
 * entity like team and org.
 */
export const useSelectedAccountEntityOrg = ({
  orgId,
  skip,
}: {
  orgId: string | undefined;
  skip?: boolean;
}) => {
  const {data, loading, error} = useSelectedAccountEntityOrgQuery({
    variables: {id: orgId ?? ''},
    skip: orgId == null || !!skip,
  });

  if (loading || error != null) {
    return {
      entityOrg: undefined,
      isLoadingEntityOrg: loading,
      entityOrgError: error,
    };
  }

  return {
    entityOrg: data?.organization?.orgEntity,
    isLoadingEntityOrg: loading,
    entityOrgError: error,
  };
};
